import { render, staticRenderFns } from "./SettingsTable.vue?vue&type=template&id=5e49fc98&scoped=true&"
import script from "./SettingsTable.vue?vue&type=script&lang=js&"
export * from "./SettingsTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTable.vue?vue&type=style&index=0&id=5e49fc98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49fc98",
  null
  
)

export default component.exports